import { call, put, takeEvery } from "redux-saga/effects";
import * as VIPCircleActions from "./vipcircle.actions";
import VIPCircleAPI from "./vipcircle.api";
import { VIPCircleActionTypes } from "./vipcircle.model";
import Swal from "sweetalert2";

export function* handleCreateVIPCircle(action) {
    try {
        const response = yield call(
            VIPCircleAPI.CreateVIPCircle,
            action.payload
        );
        yield put(VIPCircleActions.createVIPCircleSuccess(response));
        yield put(VIPCircleActions.getVIPCircleRequest());
    } catch (e) {
        yield put(VIPCircleActions.createVIPCircleFailure(e));
    }
}

export function* handleUpdateVIPCircle(action) {
    try {
        const response = yield call(
            VIPCircleAPI.UpdateVIPCircle,
            action.payload
        );
        yield put(VIPCircleActions.updateVIPCircleSuccess(response));
        yield put(VIPCircleActions.getVIPCircleRequest());
        Swal.fire({
            title: "VIP Circle",
            text: "VIP Circle updated successfully",
            icon: "success",
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
    } catch (e) {
        yield put(VIPCircleActions.updateVIPCircleFailure(e));
    }
}

export function* handleFetchVIPCircle(action) {
    try {
        const response = yield call(VIPCircleAPI.GetVIPCircles, action.payload);
        yield put(VIPCircleActions.getVIPCircleSuccess(response));
    } catch (e) {
        yield put(VIPCircleActions.getVIPCircleFailure(e));
    }
}

export function* handleFetchOtherVIPCircle(action) {
    try {
        const response = yield call(
            VIPCircleAPI.GetOtherVIPCircles,
            action.payload
        );
        yield put(VIPCircleActions.getOtherVIPCircleSuccess(response));
    } catch (e) {
        yield put(VIPCircleActions.getOtherVIPCircleFailure(e));
    }
}

export function* handleCancelVIPCircle(action) {
    try {
        const uid = action.payload.uid;
        delete action.payload.uid;
        const response = yield call(
            VIPCircleAPI.CancelRequestToJoin,
            action.payload
        );
        yield put(VIPCircleActions.cancelVIPCircleSuccess(response));
        yield put(VIPCircleActions.getOtherVIPCircleRequest(uid));
    } catch (e) {
        yield put(VIPCircleActions.cancelVIPCircleSuccess(e));
    }
}

export function* handleSendVIPCircle(action) {
    try {
        const uid = action.payload.uid;
        delete action.payload.uid;
        const response = yield call(VIPCircleAPI.RequestToJoin, action.payload);
        yield put(VIPCircleActions.sendVIPCircleSuccess(response));
        Swal.fire({
            title: "Request sent",
            text: "Please wait for the user to approve. You will not be charged until the user approves.",
            icon: "success",
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
        yield put(VIPCircleActions.getOtherVIPCircleRequest(uid));
    } catch (e) {
        yield put(VIPCircleActions.sendVIPCircleFailure(e));
    }
}

export function* handleUpsertVIPCircle(action) {
    try {
        const response = yield call(VIPCircleAPI.UpdateStatus, action.payload);
        yield put(VIPCircleActions.upsertVIPCircleSuccess(response));
    } catch (e) {
        yield put(VIPCircleActions.upsertVIPCircleFailure(e));
    }
}

export function* handleDeleteVIPCircle(action) {
    try {
        const response = yield call(
            VIPCircleAPI.DeleteVIPCircle,
            action.payload
        );
        yield put(VIPCircleActions.getVIPCircleRequest());
        yield put(VIPCircleActions.deleteVIPCircleSuccess(response));
    } catch (e) {
        yield put(VIPCircleActions.deleteVIPCircleFailure(e));
    }
}

export function* handleFetchSubscription(action) {
    try {
        const response = yield call(
            VIPCircleAPI.GetMySubscriptions,
            action.payload
        );
        yield put(VIPCircleActions.getVIPSubscriptionSuccess(response));
    } catch (e) {
        yield put(VIPCircleActions.getVIPSubscriptionFailure(e));
    }
}

export function* VIPCircleSaga() {
    yield takeEvery(
        VIPCircleActionTypes.CREATE_VIP_CIRCLE_REQUEST,
        handleCreateVIPCircle
    );
    yield takeEvery(
        VIPCircleActionTypes.UPDATE_VIP_CIRCLE_REQUEST,
        handleUpdateVIPCircle
    );
    yield takeEvery(
        VIPCircleActionTypes.FETCH_VIP_CIRCLE_REQUEST,
        handleFetchVIPCircle
    );
    yield takeEvery(
        VIPCircleActionTypes.FETCH_VIP_SUBSCRIPTION_REQUEST,
        handleFetchSubscription
    );
    yield takeEvery(
        VIPCircleActionTypes.FETCH_OTHER_VIP_CIRCLE_REQUEST,
        handleFetchOtherVIPCircle
    );
    yield takeEvery(
        VIPCircleActionTypes.SEND_VIP_CIRCLE_REQUEST,
        handleSendVIPCircle
    );
    yield takeEvery(
        VIPCircleActionTypes.CANCEL_VIP_CIRCLE_REQUEST,
        handleCancelVIPCircle
    );
    yield takeEvery(
        VIPCircleActionTypes.UPSERT_VIP_CIRCLE_REQUEST,
        handleUpsertVIPCircle
    );
    yield takeEvery(
        VIPCircleActionTypes.DELETE_VIP_CIRCLE_REQUEST,
        handleDeleteVIPCircle
    );
}
